export default __webpack_public_path__ + "static/media/users_icon.50002a7e.svg";